"use strict";

(function (Drupal) {
  Drupal.behaviors.landing_page = {
    attach: function attach(context, settings) {
      var sidebar = context.querySelector('.landing-page .right-sidebar');
      if (!sidebar) {
        return;
      }

      // Behavior needs to match up to the breakpoint of 1024px (64rem) to
      // represent desktop, but not equal to.
      var sizeMq = window.matchMedia('(max-width: 63.9375rem)');

      /* Set the sidebar height/green pine BG on mobile */
      var setSidebarHeight = function setSidebarHeight() {
        if (sizeMq.matches) {
          // We need to dynamically calculate the mobile photo overlap, so we get the photo height and divide by 1.5.
          var photoHeight = context.querySelector('.landing-page .block-field-block-node-landing-page-landing-hero').offsetHeight / 1.5;
          // We also get the offset height of the facts and add the photo height to it.
          var facts = context.querySelector('.block-field-block-node-landing-page-landing-facts').offsetHeight + photoHeight;
          // And then we position the sidebar based on the height of the first section minus the photo height.
          var topPosition = context.querySelector('.landing-page .layout__section--bottom').offsetTop - photoHeight;
          sidebar.style.height = "".concat(facts, "px");
          sidebar.style.top = "".concat(topPosition, "px");
        } else {
          sidebar.style.removeProperty('height');
          sidebar.style.removeProperty('top');
        }
      };
      window.addEventListener('load', setSidebarHeight);
      // We reset the height on resize. No debounce bc it literally makes the container bounce.
      window.addEventListener('resize', setSidebarHeight);
    }
  };
})(Drupal);